import React from 'react';
import { Skeleton } from '@mui/material';
import { ImageContainer, Wrapper } from 'app/components/mediaModule/content/contentStyles';
export default function MediaElementSkeleton(_ref) {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MediaElementSkeleton",
    "data-sentry-source-file": "MediaElementSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    as: Skeleton,
    variant: "rectangular",
    animation: animation,
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "MediaElementSkeleton.tsx"
  }));
}